import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// hooks
import { useNetworkStatus } from 'hooks/useNetworkStatus'
// types
import { IUser } from 'types/graphql'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// view components
import RiskParent from './components/Parent'
import FieldsGroup from './components/FieldsGroup'
import CustomColumns from './components/CustomColumns'
import RecurrenceColumns from './components/RecurrenceColumns'
// views
import { BasicField, RiskWrapper, UniqId } from './views'
// utils
import moment from 'moment'
import { getVisibleFields } from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/utils'

interface Props {
  isRelated?: boolean
}

const formatDate = (date: string): string => moment(date).format('D MMMM YYYY')

const formatUserName = (user?: IUser) => {
  if (!user) {
    return ''
  }

  return user.displayName ?? `${user.firstName} ${user.lastName}`
}

const Risk: React.FC<InjectedFormProps<any, Props> & Props> = ({ isRelated }) => {
  const onLine = useNetworkStatus()

  const { risk, isScheduled } = React.useContext(RiskViewContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)
  const { riskView } = React.useContext(RiskRegisterContext)

  const visibleFields = !isRelated ? getVisibleFields(riskView?.settings.fields) : ({} as Record<string, boolean>)

  const { showParent, showCreatedAt, showUpdatedAt, showCreatedBy, showUpdatedBy } = visibleFields

  const showScheduledFields = !isRelated && isScheduled
  const showIdField = onLine && riskTemplate.generateCustomerUniqueId && !isRelated

  return (
    <RiskWrapper>
      {showIdField && <UniqId>{`${riskTemplate.customerUniqueIdPrefix}${risk.customerUniqueIdPostfix}`}</UniqId>}
      {showScheduledFields && <RecurrenceColumns />}
      {showParent && <RiskParent />}
      {showCreatedAt && <BasicField>{formatDate(risk.createdAt)}</BasicField>}
      {showCreatedBy && <BasicField>{formatUserName(risk.createdBy)}</BasicField>}
      {showUpdatedAt && <BasicField>{formatDate(risk.updatedAt)}</BasicField>}
      {showUpdatedBy && <BasicField>{formatUserName(risk.updatedBy)}</BasicField>}
      {!isRelated && <CustomColumns />}
      <FieldsGroup />
    </RiskWrapper>
  )
}

export default reduxForm<any, Props>({
  enableReinitialize: true
})(Risk)
